import TicketInputRightSection from "./TicketInputRightSection";

export default TicketInputRightSection;
